import styled from 'styled-components'

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 120px;
  overflow: hidden;
  width: 100%;
  @media (max-width: 768px) {
    margin-top: 16px;
    min-height: 100px;
  }
`

export const CardRow = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(4, 1fr);
  margin-bottom: 16px;
  padding-bottom: 8px;
  width: 100%;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const VaccinesPackagesWrapperFilter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: 12px;
  padding: 12px 16px;
  background-color: #F8F8F8;
  width: 100%;

  @media (max-width: 768px) {
    max-width: 100%;
    width: 100%;
  }
`;

export const VaccinesPackagesWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  font-family: ${props => props.theme.typography.primary} !important;
  justify-content: flex-start;
  margin-bottom: 16px;
  min-height: 200px;
  padding: 1px 16px 1px;
  width: 100%;

  @media (max-width: 768px) {
    margin-bottom: 24px;
    min-height: 150px;
    padding: 1px 8px 1px;
  }
`

export const PackageTextFilter = styled.button<{ isSelected: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: ${({ isSelected }) => (isSelected ? '700' : '400')};
  color: ${({ isSelected }) => (isSelected ? '#fff' : '#464646')};
  background-color: ${({ isSelected, theme }) => (isSelected ? theme.color.primary : '#fff')};
  cursor: pointer;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.05);

  &:hover {
    background-color: ${({ isSelected, theme }) => (isSelected ? theme.color.primary : '#f0f0f0')};
  }

  &::after {
    content: '›'; 
    font-size: 16px;
    color: ${({ isSelected }) => (isSelected ? '#fff' : '#888')};
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background: #FFF;
  border-radius: 12px;
  box-shadow: 0px 4px 8px 2px rgba(183, 183, 183, 0.20);
  cursor: pointer;
  height: 126px;
  min-height: 126px;
  max-height: 126px;
  padding: 12px;
  transition: all 0.2s ease;
  width: 100%;
  gap: 0;

  /* força a família no escopo do card */
  font-family: 'Asap', 'Signika', Arial, Helvetica, sans-serif !important;

  /* garante herança para qualquer elemento interno que tente sobrepor */
  & *, &&, &&& {
    font-family: inherit !important;
  }

  @media (max-width: 768px) {
    height: 106px;
    min-height: 106px;
    max-height: 106px;
  }
`

export const CardTitle = styled.p`
  color: #464646;
  /* com fallback e aspas */
  font-family: 'Asap', 'Signika', Arial, Helvetica, sans-serif !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  white-space: normal;
  word-break: break-word;
  overflow: hidden;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 18px;
  }
`

export const CardValue = styled.p`
  color: ${props => props.theme.color.primary};
  font-family: 'Asap', 'Signika', Arial, Helvetica, sans-serif !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 18px;
  }
`

export const PackageText = styled.button<{ isSelected?: boolean }>`
  align-items: flex-start;
  align-self: stretch;
  background: none;
  border: none;
  color: ${props => props.isSelected ? props.theme.color.primary : '#464646'};
  cursor: pointer;
  display: flex;
  flex-direction: row;
  font-family: Asap;
  font-size: 16px;
  font-weight: ${props => props.isSelected ? '600' : '400'};
  padding: 8px;
  text-align: left;
  transition: all 0.2s ease;
  width: 100%;

  @media (max-width: 768px) {
    padding: 6px;
  }
`

export const VaccinesCardsText = styled.p`
  color: var(--www-fleury-com-br-tundora, #464646);
  font-family: var(--font-family-Font-1, Signika);
  font-size: var(--font-size-24, 24px);
  font-style: normal;
  font-weight: var(--font-weight-400, 400);
  line-height: var(--line-height-36, 36px);
  margin-bottom: 12px;

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 30px;
    margin-top: 24px;
  }
`

export const VaccinesPackagesText = styled.p`
  color: ${props => props.theme.color.primary};
  font-family: Asap;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 1px;
  line-height: 27px;
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 12px;
  }
`
